import React, { useEffect, useRef, useState } from "react";
import Toggle from "../../components/Toggle";
import invoicetemplate from "../../assets/images/Invoice template.png";
import invoiceTwo from "../../assets/images/Invoice-two.png";
import invoiceThree from "../../assets/images/Invoice-three.png";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { createInvoice } from "../../services/invoice";
import { getBusinessDetails, getCurrencies } from "../../services/settings";
import { MdDelete } from "react-icons/md";

const CreateInvoice = () => {
  const currentDate = new Date(); // Get the current date
  const currentMonth = String(currentDate.getMonth() + 1).padStart(2, "0"); // Get current month (0-indexed) and pad to 2 digits
  const currentDay = String(currentDate.getDate()).padStart(2, "0"); // Get current day and pad to 2 digits
  // const [selectedRows, setSelectedRows] = useState([]);
  const [customerName, setCustomerName] = useState("");
  const [customerAddress, setCustomerAddress] = useState("");
  const [customerEmail, setCustomerEmail] = useState("");
  const [invoiceType, setInvoiceType] = useState(null);
  const [currency, setCurrency] = useState("");
  const [invoiceDate, setInvoiceDate] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [companyAddress, setCompanyAdress] = useState("");
  const [items, setItems] = useState([]);
  const [month, setMonth] = useState(currentMonth);
  const [day, setDay] = useState(currentDay);
  const [year, setYear] = useState(new Date().getFullYear());
  const [daysInMonth, setDaysInMonth] = useState([]);
  const [dueDay, setDueDay] = useState(currentDay);
  const [dueMonth, setDueMonth] = useState(currentMonth);
  const [dueYear, setDueYear] = useState(new Date().getFullYear());
  const [dueDaysInMonth, setDueDaysInMonth] = useState([]);
  const [quantity, setQuantity] = useState("");
  const [description, setDescription] = useState("");
  const [unitPrice, setUnitPrice] = useState("");
  const [isEditable, setIsEditable] = useState("");
  const [currencyNames, setCurrencyNames] = useState([]);
  const [agreeTerms, setAgreeTerms] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  // Toggle row selection
  // const toggleRowSelection = (index) => {
  //   setSelectedRows(
  //     (prev) =>
  //       prev.includes(index)
  //         ? prev.filter((row) => row !== index) // Unselect row
  //         : [...prev, index] // Select row
  //   );
  // };

  const fetchCurrency = async () => {
    try {
      const res = await getCurrencies();
      setCurrencyNames(res.data);
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      }
    }
  };

  useEffect(() => {
    fetchCurrency();
  }, []);

  const fetchBusinessDetails = async () => {
    try {
      const res = await getBusinessDetails();
      setCompanyName(res.data.businessName);
      setCompanyAdress(res.data.address);
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      }
    }
  };

  useEffect(() => {
    fetchBusinessDetails();
  }, []);

  const templates = [
    {
      id: 1,
      name: "Template 1",
      imgSrc: invoicetemplate, // Replace with your actual image source
    },
    {
      id: 2,
      name: "Template 2",
      imgSrc: invoiceTwo, // Replace with another image source
    },
    {
      id: 3,
      name: "Template 3",
      imgSrc: invoiceThree, // Replace with another image source
    },
  ];

  const toggleDropdown = () => setIsDropdownOpen((prev) => !prev);

  const handleSelect = (template) => {
    setInvoiceType(template.id);
    setSelectedTemplate(template);
    setIsDropdownOpen(false);
  };

  // Close dropdown if clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Populate days dynamically based on month and year
  useEffect(() => {
    const days = [];
    const numDays = new Date(year, month, 0).getDate();
    for (let i = 1; i <= numDays; i++) {
      days.push(i.toString().padStart(2, "0"));
    }
    setDaysInMonth(days);
  }, [month, year]);

  useEffect(() => {
    const days = [];
    const numDays = new Date(dueYear, dueMonth, 0).getDate();
    for (let i = 1; i <= numDays; i++) {
      days.push(i.toString().padStart(2, "0"));
    }
    setDueDaysInMonth(days);
  }, [dueMonth, dueYear]);

  // Generate years dynamically (10 years before and after the current year)
  const generateYears = () => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let i = currentYear - 10; i <= currentYear + 10; i++) {
      years.push(i);
    }
    return years;
  };

  // Format date for the endpoint
  const getFormattedDate = (year, month, day) => {
    return `${year}-${month}-${day}`;
  };

  const handlePreviewInvoice = () => {
    if (selectedTemplate) {
      setIsModalOpen(true);
    } else {
      toast.error("Please select a template first!");
    }
  };

  const closeModal = () => setIsModalOpen(false);

  const handleQuantityChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      setQuantity(value); // Update state with the valid integer value
    }
  };

  const handleAmountChange = (e) => {
    const value = e.target.value;
    if (/^\d*\.?\d*$/.test(value)) {
      setUnitPrice(value);
    }
  };

  const handleAddItem = () => {
    if (!description || quantity <= 0 || unitPrice <= 0 || !isEditable) {
      toast.error("Please fill out all fields with valid values!");
      return;
    }

    const newItem = {
      description,
      quantity: parseInt(quantity),
      unitPrice: parseFloat(unitPrice),
      isEditable: isEditable === "true" || isEditable === true,
    };

    setItems([...items, newItem]);

    // Clear the inputs
    setDescription("");
    setQuantity("");
    setUnitPrice("");
    setIsEditable("");
  };

  const handleDeleteItem = (index) => {
    const updatedItems = items.filter((_, i) => i !== index);
    setItems(updatedItems);
  };

  const handleCheckboxChange = (e, func) => {
    if (e.target.checked) {
      func(true);
    } else {
      func(false);
    }
  };

  const handleCreateInvoice = async (e) => {
    e.preventDefault();
    if (!invoiceType) {
      toast.error("Select an invoice template");
      return;
    }
    const invoiceDay = getFormattedDate(year, month, day);
    const due = getFormattedDate(dueYear, dueMonth, dueDay);

    const payload = {
      customerName,
      customerEmail,
      customerAddress,
      invoiceType,
      invoiceDate: invoiceDay,
      dueDate: due,
      companyName,
      companyAddress,
      currency,
      items,
    };
    try {
      const res = await createInvoice(payload);
      toast.success(res.message);
      navigate(`/payments/digital-invoice/payment-invoice/${res.data.code}`);
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      }
    }
  };

  return (
    <div className="xl:w-full min-h-screen overflow-hidden">
      <div className="xl:flex xl:items-center xl:justify-between">
        <h1 className="text-2xl font-bold text-navy-blue">
          Payments - Digital Invoice
        </h1>
        <Toggle />
      </div>

      <div className=" xl:h-[1300px] mx-auto md:mx-0  h-auto bg-white max-w-72 md:max-w-full mt-8 rounded-[10px] md:p-[3rem]">
        <div className="border border-gray-200  rounded-t-[10px] p-[1rem] pl-7 flex justify-between items-center mb-8">
          <p className="text-primary text-xl font-semibold">Create Invoice</p>
          <span>
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.5 6.75L9 11.25L13.5 6.75"
                stroke="#464255"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
        </div>
        <form onSubmit={handleCreateInvoice}>
          <section className="xl:flex gap-6 justify-center px-4 py-2">
            <article className="flex-[3] flex flex-col items-center p-6 border rounded-2xl h-[650px]">
              <div className="bg-[#F6F8FC] w-full lg:w-[280px] p-2 rounded-xl font-semibold text-[16px] mb-6">
                Bill to:
              </div>

              <section className="flex flex-col gap-4">
                <div className="flex flex-col px-6 lg:px-0">
                  <label>Customer Name</label>
                  <input
                    placeholder="Mauro Sicard"
                    type="text"
                    className="lg:w-[280px] h-[50px] border outline-none rounded-[.5rem] pl-2 flex justify-center items-center mt-3"
                    onChange={(e) => setCustomerName(e.target.value)}
                    required
                  />
                </div>

                <div className="flex flex-col px-6 lg:px-0">
                  <label>Address</label>
                  <input
                    placeholder="Pablo Alto, San Francisco, CA 92102, United States of America"
                    type="text"
                    className="lg:w-[280px] h-[86px] flex-wrap border outline-none rounded-[.5rem] pl-2 flex justify-center items-center mt-3"
                    onChange={(e) => setCustomerAddress(e.target.value)}
                    required
                  />
                </div>

                <div className="flex flex-col px-6 lg:px-0">
                  <label>Email</label>
                  <input
                    placeholder="contact@maurosicard.com"
                    type="text"
                    className="lg:w-[280px] h-[50px] border outline-none rounded-[.5rem] pl-2 flex justify-center items-center mt-3"
                    onChange={(e) => setCustomerEmail(e.target.value)}
                    required
                  />
                </div>

                <div>
                  <p className="pl-7 lg:pl-0">Select Invoice Template</p>
                  <div
                    className="relative w-full lg:w-[280px]"
                    ref={dropdownRef}
                  >
                    {/* Selected Template */}
                    <div
                      className="border border-gray-300 h-[184px] rounded-lg p-3 flex items-center justify-between cursor-pointer"
                      onClick={toggleDropdown}
                    >
                      {selectedTemplate ? (
                        <div className="flex items-center gap-2">
                          <span>{selectedTemplate.name}</span>
                          <img
                            src={selectedTemplate.imgSrc}
                            alt={selectedTemplate.name}
                            className="w-[110px] h-[152.71px] rounded-md"
                          />
                        </div>
                      ) : (
                        <span>Select a Template</span>
                      )}
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className={`transition-transform ${isDropdownOpen ? "rotate-180" : "rotate-0"
                          }`}
                      >
                        <path
                          d="M4.5 6L9 10.5L13.5 6"
                          stroke="#464255"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>

                    {/* Dropdown Menu */}
                    {isDropdownOpen && (
                      <div className="absolute top-full left-0 w-full bg-white border border-gray-300 rounded-lg mt-2 shadow-lg z-10">
                        {templates.map((template) => (
                          <div
                            key={template.id}
                            className="flex items-center gap-3 p-3 cursor-pointer hover:bg-gray-100"
                            onClick={() => handleSelect(template)}
                          >
                            <span>{template.name}</span>
                            <img
                              src={template.imgSrc}
                              alt={template.name}
                              className="w-[40px] h-[40px] rounded-md"
                            />
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </section>

              <div className="flex gap-6 flex-col items-center">
                <div className="flex mt-6 items-center gap-2">
                  <section>
                    <label
                      className="container"
                      style={{ fontSize: "14px", fontWeight: 400 }}
                    >
                      Agree to terms and condition of payloft as regards payment
                      links
                      <input
                        type="checkbox"
                        name="agreeTerms"
                        checked={agreeTerms}
                        onChange={(e) => handleCheckboxChange(e, setAgreeTerms)}
                      />
                      <span
                        className="checkmark"
                        style={{ marginTop: "12px" }}
                      ></span>
                    </label>
                  </section>
                </div>

                <button
                  type="button"
                  className="text-white bg-primary w-full h-[42px] rounded-[10px]"
                  onClick={handlePreviewInvoice}
                >
                  Preview Invoice
                </button>
                {isModalOpen && (
                  <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                    <div className="relative bg-white rounded-lg shadow-lg p-4 max-w-[90%] lg:max-w-[60%]">
                      {/* Close Button */}
                      <button
                        onClick={closeModal}
                        className="absolute top-2 right-2 text-gray-500 hover:text-gray-800"
                      >
                        &times;
                      </button>

                      {/* Enlarged Image */}
                      <img
                        src={selectedTemplate.imgSrc}
                        alt={selectedTemplate.name}
                        className="w-full h-auto max-h-[80vh] rounded-md"
                      />
                    </div>
                  </div>
                )}
              </div>
            </article>

            <article className="flex-[3] lg:flex lg:flex-col lg:items-center mx-auto  p-6 border rounded-2xl h-[800px] mt-60 xl:mt-0">
              <div className="bg-[#F6F8FC] lg:w-[280px] w-full p-2 rounded-xl font-semibold text-[16px] mb-6">
                Invoice information
              </div>

              <section className="flex flex-col gap-6">
                <div className="flex flex-col">
                  <label>Currency</label>
                  <select
                    className="lg:w-[280px] h-[50px] border outline-none rounded-[.5rem] pl-2 flex justify-center items-center mt-3"
                    value={currency}
                    onChange={(e) => setCurrency(e.target.value)}
                    required
                  >
                    <option value="">Select currency</option>
                    {currencyNames.map((curr, index) => (
                      <option key={index} value={curr.code}>
                        {curr.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="flex flex-col">
                  <label>Invoice date</label>

                  <div className="lg:w-[280px] h-[50px] gap-2 border outline-none rounded-[.5rem] pl-2 flex justify-center items-center mt-3">
                    <select
                      id="month"
                      value={month}
                      className="border rounded-[50px] py-1 px-2 w-full"
                      onChange={(e) => setMonth(e.target.value)}
                    >
                      <option value="01">January</option>
                      <option value="02">February</option>
                      <option value="03">March</option>
                      <option value="04">April</option>
                      <option value="05">May</option>
                      <option value="06">June</option>
                      <option value="07">July</option>
                      <option value="08">August</option>
                      <option value="09">September</option>
                      <option value="10">October</option>
                      <option value="11">November</option>
                      <option value="12">December</option>
                    </select>
                    <select
                      id="day"
                      value={day}
                      className="border rounded-[50px] py-1 px-2"
                      onChange={(e) => setDay(e.target.value)}
                    >
                      {daysInMonth.map((d) => (
                        <option key={d} value={d}>
                          {d}
                        </option>
                      ))}
                    </select>
                    <select
                      id="year"
                      value={year}
                      className="border rounded-[50px] py-1 px-2"
                      onChange={(e) => setYear(e.target.value)}
                    >
                      {generateYears().map((y) => (
                        <option key={y} value={y}>
                          {y}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="flex flex-col">
                  <label>Payment due</label>

                  <div className="lg:w-[280px] h-[50px] gap-2 border outline-none rounded-[.5rem] pl-2 flex justify-center items-center mt-3">
                    <select
                      id="dueMonth"
                      value={dueMonth}
                      className="border rounded-[50px] py-1 px-2 w-full"
                      onChange={(e) => setDueMonth(e.target.value)}
                    >
                      <option value="01">January</option>
                      <option value="02">February</option>
                      <option value="03">March</option>
                      <option value="04">April</option>
                      <option value="05">May</option>
                      <option value="06">June</option>
                      <option value="07">July</option>
                      <option value="08">August</option>
                      <option value="09">September</option>
                      <option value="10">October</option>
                      <option value="11">November</option>
                      <option value="12">December</option>
                    </select>
                    <select
                      id="dueDay"
                      value={dueDay}
                      className="border rounded-[50px] py-1 px-2"
                      onChange={(e) => setDueDay(e.target.value)}
                    >
                      {dueDaysInMonth.map((d) => (
                        <option key={d} value={d}>
                          {d}
                        </option>
                      ))}
                    </select>
                    <select
                      id="dueYear"
                      value={dueYear}
                      className="border rounded-[50px] py-1 px-2"
                      onChange={(e) => setDueYear(e.target.value)}
                    >
                      {generateYears().map((y) => (
                        <option key={y} value={y}>
                          {y}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="flex flex-col">
                  <label>Name/Company</label>
                  <input
                    placeholder="BRIX Agency"
                    type="text"
                    className="lg:w-[280px] h-[50px] border outline-none rounded-[.5rem] pl-2 flex justify-center items-center mt-3"
                    value={companyName}
                    required
                  />
                </div>

                <div className="flex flex-col">
                  <label>Address</label>
                  <input
                    placeholder="Pablo Alto, San Francisco, CA 92102, United States of America"
                    type="text"
                    className="lg:w-[280px] h-[86px] flex-wrap border outline-none rounded-[.5rem] pl-2 flex justify-center items-center mt-3"
                    value={companyAddress}
                    required
                  />
                </div>
              </section>
            </article>

            <article className="flex-[4] flex flex-col justify-center w-full xl:h-[800px] gap-5 mt-6 lg:mt-0">
              <div className="flex-[5] p-6 h-[400px] border rounded-2xl">
                <div className="bg-[#F6F8FC] w-full p-2 rounded-xl font-semibold text-[16px] mb-6">
                  Add Items
                </div>

                <section className="flex flex-col gap-6">
                  <div className="flex flex-col">
                    <label>Description</label>
                    <input
                      placeholder="Pablo Alto, San Francisco, CA 94109, United States of America"
                      type="text"
                      value={description}
                      className="w-full h-[86px] flex-wrap border outline-none rounded-[.5rem] pl-2 flex justify-center items-center mt-3"
                      onChange={(e) => setDescription(e.target.value)}
                    />
                  </div>

                  <article className="xl:flex gap-3">
                    <section>
                      <label>Quantity</label>
                      <div>
                        <input
                          type="text"
                          value={quantity}
                          onChange={handleQuantityChange}
                          className="lg:w-[110px] w-full h-[50px] gap-2 border outline-none rounded-[.5rem] px-2 mt-3"
                        />
                      </div>
                    </section>

                    <section>
                      <label>Amount</label>
                      <div>
                        <input
                          type="text"
                          value={unitPrice}
                          onChange={handleAmountChange}
                          className="lg:w-[110px] w-full h-[50px] border outline-none rounded-[.5rem] px-2 mt-3"
                        />
                      </div>
                    </section>

                    <section className="flex flex-col">
                      <label>Item Type</label>
                      <select
                        value={isEditable}
                        className="lg:w-[130px] w-full h-[50px] gap-2 border outline-none rounded-[.5rem] px-2 mt-3"
                        onChange={(e) => setIsEditable(e.target.value)}
                      >
                        <option value="" disabled hidden>
                          Select Item Type
                        </option>
                        <option value="true">Editable</option>
                        <option value="false">Not Editable</option>
                      </select>
                    </section>
                  </article>

                  <div className="flex justify-end">
                    <button
                      className="text-white bg-primary w-[180px] h-[42px] rounded-[10px]"
                      type="button"
                      onClick={handleAddItem}
                    >
                      Add Item
                    </button>
                  </div>
                </section>
              </div>

              <div className="flex-[5] p-6 h-[400px] border rounded-2xl mt-11 lg:mt-24 xl:mt-0">
                <div className="bg-[#F6F8FC] w-full p-2 rounded-xl font-semibold text-[16px] mb-6">
                  Added Items
                </div>

                <div className="bg-white rounded-md shadow-sm overflow-hidden">
                  <DataTable
                    value={items}
                    emptyMessage="No items added yet."
                    className="p-datatable-sm"
                    responsiveLayout="scroll"
                  >
                    <Column
                      field="description"
                      header="Description"
                      body={(row) => <div className="py-2">{row.description}</div>}
                    />
                    <Column
                      field="unitPrice"
                      header="Amount"
                      body={(row) => (
                        <div className="py-2">
                          {row.unitPrice != null
                            ? Number(row.unitPrice).toFixed(2)
                            : "-"}
                        </div>
                      )}
                    />
                    <Column
                      field="quantity"
                      header="Quantity"
                      body={(row) => (
                        <div className="py-2 text-center">{row.quantity}</div>
                      )}
                    />
                    <Column
                      field="isEditable"
                      header="isEditable"
                      body={(row) => (
                        <div className="py-2 text-center">
                          {row.isEditable ? "true" : "false"}
                        </div>
                      )}
                    />
                    <Column
                      header="Action"
                      body={(row, { rowIndex }) => (
                        <div className="flex justify-center cursor-pointer text-red-500 hover:text-red-700 py-2">
                          <MdDelete
                            onClick={() => handleDeleteItem(rowIndex)}
                            className="text-xl"
                          />
                        </div>
                      )}
                    />
                  </DataTable>
                </div>
              </div>
              <div className="flex justify-end">
                <button
                  className="text-white bg-primary w-[180px] h-[42px] disabled:bg-[rgba(var(--primary-rgb),0.2)] disabled:cursor-not-allowed rounded-[10px]"
                  type="submit"
                  disabled={!agreeTerms}
                >
                  Create Invoice
                </button>
              </div>
            </article>
          </section>
        </form>
      </div>
    </div>
  );
};

export default CreateInvoice;
